import { createContext } from 'react';

export const AngebotContext = createContext(null);
